(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[457],{

/***/ "TqPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhoneBubble", function() { return PhoneBubble; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var PhoneBubble = function PhoneBubble(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 747.2"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M239.2 597.2c-5.1-5-14.2-6.1-20.3-2.3l-48.3 30.3c-6.2 3.8-14.1 2-17.9-4.1L84.6 512.7c-3.8-6.1-1.9-14.1 4.1-17.9l45.4-28.5c6.1-3.8 8.8-12.3 6.1-19L94.8 336.5c-2.7-6.6-10.2-9.5-16.7-6.4 0 0-62 29.6-70.8 67.9C-28.4 554.6 69.4 710.5 226 746.4c38.3 8.8 91.6-52.9 91.6-52.9 4.7-5.5 4.4-14-.7-19l-77.7-77.3zm-22.3-114.3c-6.2 0-11.1-5-11.1-11.1 0-6.2 5-11.1 11.1-11.1 20.1 0 37.8-16.8 37.8-35.9 0-11-3.2-24.2-10.2-28.1C157 372.7 96 292.8 96 202 96 90.6 186.6 0 298 0s202 90.6 202 202c0 78.2-32.9 150.9-92.7 204.6-53.3 47.8-124.4 76.3-190.4 76.3zM298 22.2c-99.1 0-179.8 80.6-179.8 179.8 0 81.2 54.7 152.6 133 173.6.6.2 1.2.4 1.7.6 22.1 10.1 23.9 39.8 23.9 48.6 0 10.9-3.3 21.3-9 30.1 107.5-24.1 210-121.3 210-252.9 0-99.2-80.6-179.8-179.8-179.8z"
  }), __jsx("path", {
    d: "M250.4 202c0 12-9.7 21.7-21.7 21.7S207 214 207 202s9.7-21.7 21.7-21.7 21.7 9.7 21.7 21.7zm72.7 0c0 12-9.7 21.7-21.7 21.7s-21.7-9.7-21.7-21.7 9.7-21.7 21.7-21.7 21.7 9.7 21.7 21.7zm72.7 0c0 12-9.7 21.7-21.7 21.7s-21.7-9.7-21.7-21.7 9.7-21.7 21.7-21.7 21.7 9.7 21.7 21.7z"
  }));
};

/***/ })

}]);